import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader, XCircle } from 'lucide-react';
import Navbar from '../shared/Navbar';

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const sessionId = searchParams.get("session_id");

        if (sessionId) {
            // Optional: verify session with backend
            console.log("Session ID:", sessionId);
        }

        // After 10 seconds, go to dashboard
        setTimeout(() => {
            navigate("/parent/dashboard");
        }, 10000);

    }, []);

    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />

            <div className="max-w-2xl mx-auto px-4 py-20">
                <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
                        <>
                            <h2 className="text-2xl font-bold mb-2">Verifying Payment...</h2>
                            <p className="text-gray-600">Please wait while we confirm your payment</p>
                        </>
                        <>

                            <div className="bg-purple-50 rounded-xl p-6 mb-8 text-left">
                                <h3 className="font-bold text-lg mb-4">Next Steps:</h3>
                                <div className="space-y-3">
                                    <div className="flex items-start gap-3">
                                        <span className="flex-shrink-0 w-6 h-6 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold">1</span>
                                        <p className="text-gray-700">
                                            Set up your child’s account from the Parent Dashboard.
                                        </p>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <span className="flex-shrink-0 w-6 h-6 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold">2</span>
                                        <p className="text-gray-700">
                                            Download the STEM4Kiddo mobile app from the Google Play Store and log in using the User ID and Password available in your dashboard.
                                        </p>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <span className="flex-shrink-0 w-6 h-6 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold">3</span>
                                        <p className="text-gray-700">
                                            Your child can now start learning and continue their STEM journey!
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <button
                                onClick={() => navigate('/parent/dashboard')}
                                className="btn-primary"
                            >
                                Go to Dashboard
                            </button>
                        </>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;